import { useState, useCallback, useEffect } from 'react';
import companyServices from 'services/company.services';

export default function useGetCompanyInstantPayoutType() {
  const [loading, setLoading] = useState(false);
  const [listCompanyInstantPayoutTypes, setListCompanyInstantPayoutTypes] = useState([]);

  const getCompanyInstantPayoutTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await companyServices.listCompanyInstantPayoutType();
      setListCompanyInstantPayoutTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getCompanyInstantPayoutTypes();
  }, []);

  return {
    loading,
    listCompanyInstantPayoutTypes,
    getCompanyInstantPayoutTypes
  };
}
